/*
 * SABBIA SKIO DESIGN OVERRIDE v2
 *
 * Load AFTER skio-plan-picker-component.js. Do NOT edit Skio's file.
 *
 * Skio's selling plan logic stays untouched:
 *   - every plan Skio returns is shown (nothing is filtered out)
 *   - the native <select> stays in the DOM (visually hidden)
 *   - the custom dropdown sets select.value and fires "change",
 *     so Skio updates the hidden selling_plan input as usual
 */

(() => {
  'use strict';

  /* ---------------------------------------------------------
   * CONFIG
   * --------------------------------------------------------- */

  const STYLE_ID = 'sabbia-skio-design-v2';

  // Note shown next to a frequency, keyed by number of weeks.
  // Plans without a note still show, just without the brackets.
  const PLAN_NOTES = {
    6: 'Recommended for daily skincare',
    9: 'Recommended for BB cream + skin tools',
    12: 'Ideal for lighter use or travelling',
  };

  const SORT_PLANS = true;          // shortest frequency first (display only)
  const SHOW_MAIN_PRICE = false;     // big price above the cards
  const POPULAR_TEXT = 'Most popular';
  const USAGE_LABEL = 'Recommended usage';

  /* ---------------------------------------------------------
   * ICONS (line icons used as CSS masks, colour = currentColor)
   * Order matches the 4 <li> items in "Additional subscription content"
   * --------------------------------------------------------- */

  const icon = (paths) =>
    `url("data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'>${paths}</svg>`
    )}")`;

  const ICONS = [
    // 15% off
    icon("<circle cx='12' cy='12' r='10'/><path d='M8.5 15.5l7-7'/><circle cx='9' cy='9' r='1.3'/><circle cx='15' cy='15' r='1.3'/>"),
    // full size bottle
    icon("<path d='M10 2h4v3h-4z'/><path d='M9 5h6v2.5l1.5 1.5V22h-9V9L9 7.5z'/><path d='M7.5 12h9'/>"),
    // free shipping
    icon("<path d='M1.5 6h12v10h-12z'/><path d='M13.5 9h4l3.5 3.5V16h-7.5'/><circle cx='5.5' cy='18' r='1.8'/><circle cx='17' cy='18' r='1.8'/>"),
    // pause / skip / cancel
    icon("<path d='M20 11a8 8 0 0 0-14.3-4.3L4 9'/><path d='M4 4v5h5'/><path d='M4 13a8 8 0 0 0 14.3 4.3L20 15'/><path d='M20 20v-5h-5'/>"),
  ];

  const CHEVRON =
    '<svg class="sabbia-dd__chev" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  const CHECK =
    '<svg class="sabbia-dd__check" viewBox="0 0 14 14" aria-hidden="true"><path d="M2.5 7.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  /* ---------------------------------------------------------
   * STYLES (injected into Skio's shadow root)
   * --------------------------------------------------------- */

  const C = {
    ink: '#1f1a17',
    muted: '#5d534b',
    brown: '#6b2b17',
    brownDark: '#4a1f10',
    card: '#fbf9f5',
    cardSelected: '#ece5d9',
    line: '#e4ddd1',
    divider: '#d6ccbd',
  };

  const styleCSS = `
    :host { display: block !important; width: 100% !important; min-width: 0 !important; }

    .skio-plan-picker {
      display: flex !important;
      flex-direction: column !important;
      gap: 12px !important;
      width: 100% !important;
      margin: 0 0 16px !important;
      padding: 0 !important;
      border: 0 !important;
      color: ${C.ink} !important;
      font-family: inherit !important;
    }

    /* Main price */
    .sabbia-main-price {
      margin: 0 0 4px;
      color: ${C.ink};
      font-size: 32px;
      line-height: 1.1;
      font-weight: 400;
      letter-spacing: -0.01em;
    }
    .sabbia-main-price:empty { display: none; }

    /* Cards */
    .group-container {
      position: relative !important;
      box-sizing: border-box !important;
      width: 100% !important;
      border: 1px solid ${C.line} !important;
      border-radius: 6px !important;
      background: ${C.card} !important;
      color: ${C.ink} !important;
      transition: border-color .2s ease, background-color .2s ease !important;
    }
    .group-container:hover { border-color: #cbbfae !important; }
    .group-container--selected {
      border-color: ${C.cardSelected} !important;
      background: ${C.cardSelected} !important;
    }

    .group-label {
      display: flex !important;
      flex-direction: column !important;
      box-sizing: border-box !important;
      width: 100% !important;
      padding: 18px 16px !important;
      cursor: pointer !important;
    }

  //  .group-topline {
  //     display: flex !important;
  //     align-items: center !important;
  //     gap: 12px !important;
  //     width: 100% !important;
  //   }
      
    // .group-title {
    //   flex: 1 1 auto !important;
    //   min-width: 0 !important;
    //   max-width: none !important;
    //   padding: 0 !important;
    //   color: ${C.ink} !important;
    //   font-size: 16px !important;
    //   line-height: 1.3 !important;
    //   font-weight: 400 !important;
    // }
    .group-container--selected .group-title {
      color: ${C.brownDark} !important;
      font-size: 18px !important;
      font-weight: 600 !important;
    }

    .savings.bubble {
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      background: none !important;
      color: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
    }

    /* Radio */
    // .skio-radio__container { flex: 0 0 auto !important; display: flex !important; color: ${C.ink} !important; } 
    .group-container--selected .skio-radio__container { color: ${C.brown} !important; }
    // .skio-radio__container svg { width: 20px !important; height: 20px !important; }

    /* "PAY $80.75" line */
    .skio-price {
      margin: 4px 0 0 30px !important;
      padding: 0 !important;
      justify-content: flex-start !important;
      text-align: left !important;
      color: ${C.muted} !important;
      font-size: 11px !important;
      line-height: 1.4 !important;
      font-weight: 400 !important;
      letter-spacing: .12em !important;
      text-transform: uppercase !important;
    }
    .skio-price::before { content: 'Pay'; margin-right: 5px; }
    .skio-price s { display: none !important; }

    /* Most popular badge */
    .sabbia-popular {
      flex: 0 0 auto;
      margin-left: auto;
      padding: 6px 12px;
      border-radius: 999px;
      background: ${C.brown};
      color: #fff;
      font-size: 9px;
      line-height: 1;
      letter-spacing: .14em;
      text-transform: uppercase;
      white-space: nowrap;
      margin-top: -66px;
    }

    /* Subscription content */
    .group-content {
      box-sizing: border-box !important;
      width: 100% !important;
      margin: 18px 0 0 !important;
      padding: 0 !important;
    }

    /* Benefits row */
    .group-content-additional {
      width: 100% !important;
      margin: 0 0 18px !important;
      padding: 0 !important;
    }
    .group-content-additional ul {
      display: grid !important;
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
      margin: 0 !important;
      padding: 0 !important;
      list-style: none !important;
    }
    .group-content-additional li {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      gap: 10px !important;
      margin: 0 !important;
      padding: 2px 8px !important;
      border-right: 1px solid ${C.divider} !important;
      color: ${C.ink} !important;
      text-align: center !important;
      font-size: 9px !important;
      line-height: 1.5 !important;
      letter-spacing: .1em !important;
      text-transform: uppercase !important;
    }
    .group-content-additional li:last-child { border-right: 0 !important; }
    .group-content-additional li::marker { content: ''; }
    .group-content-additional li::before {
      content: '';
      display: block;
      flex: 0 0 auto;
      width: 28px;
      height: 28px;
      background: currentColor;
      -webkit-mask: var(--sabbia-icon) center / contain no-repeat;
      mask: var(--sabbia-icon) center / contain no-repeat;
    }
    .group-content-additional li:nth-child(1) { --sabbia-icon: ${ICONS[0]}; }
    .group-content-additional li:nth-child(2) { --sabbia-icon: ${ICONS[1]}; }
    .group-content-additional li:nth-child(3) { --sabbia-icon: ${ICONS[2]}; }
    .group-content-additional li:nth-child(4) { --sabbia-icon: ${ICONS[3]}; }

    /* Native frequency select: kept for Skio, hidden from view */
    .selling-plan-dropdown-label { display: none !important; }
    [data-sabbia-native] {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    /* Custom dropdown */
    .sabbia-dd { width: 100%; }

    .sabbia-usage-label {
      display: block;
      margin: 0 0 8px;
      color: ${C.muted};
      font-size: 10px;
      letter-spacing: .14em;
      text-transform: uppercase;
    }

    .sabbia-dd__trigger {
      display: flex;
      align-items: center;
      gap: 8px;
      box-sizing: border-box;
      width: 100%;
      min-height: 48px;
      padding: 12px 14px;
      border: 1px solid #b9a998;
      border-radius: 6px;
      background: #fff;
      color: ${C.ink};
      font: inherit;
      font-size: 14px;
      text-align: left;
      cursor: pointer;
    }
    .sabbia-dd__trigger:focus-visible { outline: 2px solid ${C.brown}; outline-offset: 2px; }
    .sabbia-dd__value { flex: 1 1 auto; min-width: 0; }
    .sabbia-dd__note { color: ${C.muted}; font-size: 12px; }
    .sabbia-dd__chev { flex: 0 0 auto; width: 12px; height: 12px; transition: transform .2s ease; }
    .sabbia-dd--open .sabbia-dd__chev { transform: rotate(180deg); }

    .sabbia-dd__list {
      display: none;
      margin: 4px 0 0;
      padding: 4px;
      list-style: none;
      border: 1px solid ${C.line};
      border-radius: 6px;
      background: #fff;
      outline: none;
    }
    .sabbia-dd--open .sabbia-dd__list { display: block; }

    .sabbia-dd__opt {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 14px;
      border-bottom: 1px solid #efe9df;
      font-size: 14px;
      cursor: pointer;
    }
    .sabbia-dd__opt:last-child { border-bottom: 0; }
    .sabbia-dd__opt:hover,
    .sabbia-dd__opt.is-active { background: #f6f1e9; }
    .sabbia-dd__opt[aria-selected='true'] { background: ${C.cardSelected}; }
    .sabbia-dd__check { flex: 0 0 auto; width: 14px; height: 14px; margin-left: auto; color: ${C.brown}; visibility: hidden; }
    .sabbia-dd__opt[aria-selected='true'] .sabbia-dd__check { visibility: visible; }

    .skio-details { display: none !important; }


    .group-topline {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 0px !important;
}

.skio-radio__container {
  display: flex !important;
  align-items: center !important;
  margin-right: 10px !important;
}

.group-title {
  display: flex !important;
  align-items: center !important;
  gap: 6px;
}

.skio-price {
  width: 100% !important;
  padding-left: 0px !important; /* radio ke according align */
}

    @media (prefers-reduced-motion: reduce) {
      .group-container, .sabbia-dd__chev { transition: none !important; }
    }

    @media screen and (max-width: 749px) {
      .sabbia-main-price { font-size: 28px; }
      .group-label { padding: 16px 14px !important; }
      .skio-price { margin-left: 30px !important; }
      .group-content-additional li {
        gap: 8px !important;
        padding: 2px 4px !important;
        font-size: 8px !important;
        letter-spacing: .08em !important;
      }
      .group-content-additional li::before { width: 24px; height: 24px; }
      .sabbia-dd__trigger, .sabbia-dd__opt { font-size: 13px; }
      .sabbia-dd__note { font-size: 11px; }
      .group-container--selected .group-title {
      font-size: 14px !important;
     }
     .group-title {
      font-size: 14px;
     } 
       .sabbia-popular {
      margin-top: -24px;
    }
    }
     @media (max-width: 376px) {
      .sabbia-popular {
      margin-top: -18px;
      padding: 6px 6px;
      font-size: 6px;
      letter-spacing: 0;
     }
    }
  `;

  /* ---------------------------------------------------------
   * HELPERS
   * --------------------------------------------------------- */

  const escapeHtml = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // "Delivery 6 weeks" -> { label: "6 Weeks", note: "...", sortKey: 42 }
  function parsePlan(text) {
    const clean = String(text || '').trim();
    const m = clean.match(/(\d+)\s*(day|week|month|year)s?/i);
    if (!m) return { label: clean, note: '', sortKey: 1e9 };

    const n = Number(m[1]);
    const unit = m[2].toLowerCase();
    const unitLabel = unit.charAt(0).toUpperCase() + unit.slice(1) + (n === 1 ? '' : 's');
    const days = { day: 1, week: 7, month: 30, year: 365 }[unit];

    return {
      label: `${n} ${unitLabel}`,
      note: unit === 'week' ? PLAN_NOTES[n] || '' : '',
      sortKey: n * days,
    };
  }

  const planHtml = (p) =>
    escapeHtml(p.label) + (p.note ? ` <span class="sabbia-dd__note">(${escapeHtml(p.note)})</span>` : '');

  /* ---------------------------------------------------------
   * CUSTOM DROPDOWN
   * --------------------------------------------------------- */

  const openDropdowns = new Set();
  let uid = 0;

  function toggle(wrap, open) {
    const trigger = wrap.querySelector('.sabbia-dd__trigger');
    const list = wrap.querySelector('.sabbia-dd__list');

    wrap.classList.toggle('sabbia-dd--open', open);
    trigger.setAttribute('aria-expanded', String(open));

    if (open) {
      openDropdowns.add(wrap);
      const opts = [...list.children];
      const i = opts.findIndex((o) => o.getAttribute('aria-selected') === 'true');
      setActive(wrap, i < 0 ? 0 : i);
      list.focus();
    } else {
      openDropdowns.delete(wrap);
    }
  }

  function setActive(wrap, index) {
    const list = wrap.querySelector('.sabbia-dd__list');
    [...list.children].forEach((o, i) => {
      const active = i === index;
      o.classList.toggle('is-active', active);
      if (active) {
        list.setAttribute('aria-activedescendant', o.id);
        o.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  function choose(wrap, value) {
    const select = wrap.__select;
    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }
    toggle(wrap, false);
    wrap.querySelector('.sabbia-dd__trigger').focus();
    syncSelected(wrap);
  }

  function buildDropdown(select) {
    const id = `sabbia-dd-${++uid}`;
    const wrap = document.createElement('div');
    wrap.className = 'sabbia-dd';
    wrap.dataset.id = id;
    wrap.innerHTML = `
      <span class="sabbia-usage-label" id="${id}-label">${escapeHtml(USAGE_LABEL)}</span>
      <button type="button" class="sabbia-dd__trigger" aria-haspopup="listbox" aria-expanded="false"
        aria-labelledby="${id}-label ${id}-value">
        <span class="sabbia-dd__value" id="${id}-value"></span>${CHEVRON}
      </button>
      <ul class="sabbia-dd__list" role="listbox" tabindex="-1" aria-labelledby="${id}-label"></ul>
    `;

    // If Skio wraps the select in its label, place the dropdown after the label
    const anchor = select.closest('.selling-plan-dropdown-label') || select;
    anchor.parentNode.querySelectorAll(':scope > .sabbia-dd').forEach((n) => n.remove());
    anchor.after(wrap);

    const trigger = wrap.querySelector('.sabbia-dd__trigger');
    const list = wrap.querySelector('.sabbia-dd__list');

    // The dropdown sits inside Skio's group <label>; stop clicks from
    // reaching it so the group radio is not re-triggered.
    wrap.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    trigger.addEventListener('click', () => toggle(wrap, !wrap.classList.contains('sabbia-dd--open')));

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        toggle(wrap, true);
      }
    });

    list.addEventListener('click', (e) => {
      const opt = e.target.closest('.sabbia-dd__opt');
      if (opt) choose(wrap, opt.dataset.value);
    });

    list.addEventListener('keydown', (e) => {
      const opts = [...list.children];
      let i = opts.findIndex((o) => o.classList.contains('is-active'));

      switch (e.key) {
        case 'ArrowDown': i = Math.min(opts.length - 1, i + 1); break;
        case 'ArrowUp': i = Math.max(0, i - 1); break;
        case 'Home': i = 0; break;
        case 'End': i = opts.length - 1; break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (opts[i]) choose(wrap, opts[i].dataset.value);
          return;
        case 'Escape':
          e.preventDefault();
          toggle(wrap, false);
          trigger.focus();
          return;
        case 'Tab':
          toggle(wrap, false);
          return;
        default:
          return;
      }
      e.preventDefault();
      setActive(wrap, i);
    });

    return wrap;
  }

  function renderOptions(wrap, options) {
    const plans = options.map((o) => ({ value: o.value, ...parsePlan(o.textContent) }));
    if (SORT_PLANS) plans.sort((a, b) => a.sortKey - b.sortKey);

    wrap.__plans = plans;
    wrap.querySelector('.sabbia-dd__list').innerHTML = plans
      .map(
        (p, i) => `
        <li class="sabbia-dd__opt" role="option" id="${wrap.dataset.id}-opt-${i}"
          data-value="${escapeHtml(p.value)}" aria-selected="false">
          <span>${planHtml(p)}</span>${CHECK}
        </li>`
      )
      .join('');
  }

  function syncSelected(wrap) {
    const value = wrap.__select ? wrap.__select.value : '';
    const plans = wrap.__plans || [];
    const plan = plans.find((p) => p.value === value) || plans[0];

    const valueEl = wrap.querySelector('.sabbia-dd__value');
    const key = plan ? plan.value : '';
    if (valueEl.dataset.v !== key) {
      valueEl.dataset.v = key;
      valueEl.innerHTML = plan ? planHtml(plan) : '';
    }

    wrap.querySelectorAll('.sabbia-dd__opt').forEach((o) => {
      const selected = String(o.dataset.value === key);
      if (o.getAttribute('aria-selected') !== selected) o.setAttribute('aria-selected', selected);
    });
  }

  function enhanceSelect(select) {
    const options = [...select.options].filter((o) => !o.disabled && o.value !== '');
    const signature = options.map((o) => `${o.value}|${o.textContent.trim()}`).join(',');

    let wrap = select.__sabbiaDd;
    if (!wrap || !wrap.isConnected) {
      wrap = buildDropdown(select);
      select.__sabbiaDd = wrap;
    }
    wrap.__select = select;

    if (!select.hasAttribute('data-sabbia-native')) {
      select.setAttribute('data-sabbia-native', '');
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;
    }

    if (wrap.dataset.sig !== signature) {
      wrap.dataset.sig = signature;
      renderOptions(wrap, options);
    }

    syncSelected(wrap);
  }

  // Close open dropdowns on outside click (inside clicks are stopped above)
  document.addEventListener('click', () => {
    openDropdowns.forEach((wrap) => toggle(wrap, false));
  });

  /* ---------------------------------------------------------
   * OTHER DESIGN PIECES
   * --------------------------------------------------------- */

  function addStyles(root) {
    if (root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styleCSS;
    root.appendChild(style);
  }

  function updateMainPrice(el, root) {
    if (!SHOW_MAIN_PRICE) return;
    const picker = root.querySelector('.skio-plan-picker');
    if (!picker) return;

    let price = root.querySelector('.sabbia-main-price');
    if (!price) {
      price = document.createElement('div');
      price.className = 'sabbia-main-price';
      picker.insertBefore(price, picker.firstElementChild);
    }

    try {
      if (el.selectedVariant && typeof el.money === 'function') {
        const text = el.money(el.selectedVariant.price);
        if (price.textContent !== text) price.textContent = text;
      }
    } catch (err) {
      console.warn('[Sabbia Skio] price:', err);
    }
  }

  // Badge on the first subscription card (Skio shows one-time first)
  function updatePopularBadge(root) {
    const groups = root.querySelectorAll('.group-container');
    groups.forEach((group, index) => {
      const topline = group.querySelector('.group-topline');
      if (!topline) return;
      const badge = topline.querySelector('.sabbia-popular');

      if (index === 1) {
        if (!badge) {
          const el = document.createElement('span');
          el.className = 'sabbia-popular';
          el.textContent = POPULAR_TEXT;
          topline.appendChild(el);
        }
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function updateDesign(el) {
    const root = el.shadowRoot;
    if (!root) return;

    addStyles(root);
    updateMainPrice(el, root);
    updatePopularBadge(root);
    root.querySelectorAll('select.selling-plan-dropdown').forEach(enhanceSelect);
  }

  /* ---------------------------------------------------------
   * OBSERVE SKIO (Lit re-renders the shadow DOM on state changes)
   * --------------------------------------------------------- */

  function observeSkio(el) {
    if (el.__sabbiaObserved) return;
    el.__sabbiaObserved = true;

    let observer = null;
    let queued = false;
    let tries = 0;

    const run = () => {
      queued = false;
      if (!el.shadowRoot) return;

      // Pause the observer so our own DOM changes don't retrigger it
      observer.disconnect();
      try {
        updateDesign(el);
      } catch (err) {
        console.warn('[Sabbia Skio]', err);
      }
      observer.observe(el.shadowRoot, { childList: true, subtree: true, characterData: true });
    };

    const schedule = () => {
      if (queued || !observer) return;
      queued = true;
      requestAnimationFrame(run);
    };

    const waitForShadow = () => {
      if (!el.shadowRoot) {
        if (++tries < 100) setTimeout(waitForShadow, 100);
        return;
      }
      observer = new MutationObserver(schedule);
      run();
    };

    waitForShadow();
    el.addEventListener('change', schedule);
    document.addEventListener('variant:change', schedule);
  }

  /* ---------------------------------------------------------
   * FIND SKIO COMPONENTS (incl. theme editor / quick add)
   * --------------------------------------------------------- */

  let scanQueued = false;
  const scan = () => {
    scanQueued = false;
    document.querySelectorAll('skio-plan-picker').forEach(observeSkio);
  };
  const scheduleScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(scan);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  new MutationObserver(scheduleScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();